module.exports = __webpack_public_path__ + "static/media/es.02092f7e.png";